module.exports = __webpack_public_path__ + "img/pre_active_icon.1844b3a.png";